import { IIdsRequest } from "../../model/request/IIdsRequest";
import { ITietThi } from "../../model/respone/tct/ITietThi";
import { apiClient } from "../apiClient";

export const TIET_THI_RESOURCE = "tiet-thi";
export const tietThiApi = {
  SelectAll: () => apiClient.get(`${TIET_THI_RESOURCE}`),
  Insert: (payload: ITietThi) => apiClient.post(`${TIET_THI_RESOURCE}`, payload),
  Update: (payload: ITietThi) => apiClient.put(`${TIET_THI_RESOURCE}`, payload),
  Delete: (id: number) => apiClient.delete(`${TIET_THI_RESOURCE}/${id}`),
  Deletes: (ids: IIdsRequest) => apiClient.put(`${TIET_THI_RESOURCE}/deletes`,ids),
};
